module.exports = __webpack_public_path__ + "img/Halt-OD.64ce747b.svg";